import React from 'react';
import { ISettlementItemForm } from 'types/order/fees/ICreateSettlementItemForm';
import { ISectionData } from 'types/order/fees/ISectionData';
import { ISectionDefinitionData } from 'types/order/fees/ISectionDefinition';
import { CDValidationContainer } from './CDValidationContainer';
import { ItemValidationContainer } from './ItemValidationContainer';
import { IOrderTagData } from 'types/order/tags/IOrderTagData';

export interface IValidationProps {
  currentLineItem?: ISettlementItemForm;
  sections: ISectionData[];
  sectionDefinitions: ISectionDefinitionData[];
  tags?: IOrderTagData[];
  className?: string;
}

export const Validation: React.FC<IValidationProps> = (props) => {
  return (
    <>
      <CDValidationContainer {...props} />
      <ItemValidationContainer {...props} />
    </>
  );
};
